import * as Yup from 'yup';
import { nameValidationSchema } from '../validations';

export const companyValidationSchema = Yup.object().shape({
  name: nameValidationSchema,
  stateId:  Yup.number()
  .required('Stát musí být vybrán')
  .min(1, 'Stát musí být vybrána'),
});
